<template>
  <v-app>
    <v-main>
      <v-container class="fill-height" style="opacity: 0.9" fluid>
        <v-row justify="center">
          <v-col cols="12" sm="12" md="8">
            <v-card elevation="24" shaped color="rgb(0, 0, 0, 0.8)">
              <v-card-text>
                <br />
                <br />
                <br />
                <div>
                  <h1 class="custom-title">Welcome to Youvendo!</h1>
                </div>
                <br />
                <br />
                <br />
                <div class="err-p">
                  <p>
                    You need to log in, by your own provided email id and
                    password to proceed further!
                  </p>
                  <p>To proceed further <a href="/admin">Click Here</a></p>
                  <p>&mdash; The Dev Team</p>
                </div>
                <br />
                <br />
                <br />
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
  export default {
    props: {
      source: String
    },
    data() {
      return {}
    }
  }
</script>

<style>
  .err-p {
    font-size: 1.7em;
    line-height: 1.5em;
  }
  .custom-title {
    font-size: 50px;
  }
  .custom-lnk {
    text-decoration: none;
  }
  .custom-lnk:hover {
    color: #333;
    text-decoration: none;
  }
</style>
